import { type PropsWithChildren } from "react";
import { FeatureFlagContext } from "./feature-flag-context";
import { useGetFeatureFlags } from "./query";

export const FeatureFlagProvider = ({ children }: PropsWithChildren) => {
  const { data: featureFlags, isLoading, isError } = useGetFeatureFlags();

  return (
    <FeatureFlagContext.Provider
      value={{
        featureFlags,
        isLoading,
        isError,
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};
